// --- React
import React from 'react';
// --- UI Components
import Button from '@dtci/spellbook/Button';

/**
 * ClickableCellRenderer Component
 *
 * This component is a cell renderer for AG Grid that renders a clickable button.
 * It takes an action function and a button icon as props.
 * When the button is clicked, it performs the specified action.
 *
 * @param {Function} action - The action to be performed when the button is clicked.
 * @param {function(*): string} buttonIcon - The icon to be displayed on the button.
 * @returns {JSX.Element} The rendered button component.
 **/
export const ClickableCellRenderer = (action, buttonIcon) => {
    const Renderer = ({ value, data }) => {
        const disabled =
            action?.name === 'onDeleteDateMathCalculation' &&
            ((data.dateMathCreateType !== 'UPDATE' &&
                data?.dateMathCreateType !== 'UPDATE_ADV' &&
                data?.sourceRightslineId !== null &&
                data?.sourceRightslineId !== '') ||
                (data?.dateMathCreateType === 'UPDATE' && data?.loadStatus === 'COMPLETE'));

        let job = { ...data };
        if (value === 'START JOB') {
            job.action = 'start';
        } else if (value === 'DELETE JOB') {
            job.action = 'delete';
        }

        return (
            <Button
                style={{ color: disabled ? '#b0b0b0' : '#3611c8' }}
                iconType={`fa-regular ${buttonIcon}`}
                type="button"
                styleType="link"
                className="sb-typography sb-typography_T20 sb-typography_truncate"
                onClick={() => action(job)}
                disabled={disabled}
            >
                {value}
            </Button>
        );
    };

    return Renderer;
};
